$(document).ready(function(){
	
	// Menu
	$('body').mouseup(function(e) {

		$('.menu-trigger').on('click', function() {
			$('.main-menu').toggleClass('visible');
			$(this).toggleClass('active');
		});	

	    var container = $('.main-menu');
	    // if the target of the click isn't the container nor a descendant of the container
	    if (!container.is(e.target) && container.has(e.target).length === 0) {
	        container.removeClass('visible');
	        $('.menu-trigger').removeClass('active');
	    }
	});

	if ( $('.mijn-receptern-page').length ) {
		console.log('mir-receptern-here!');
		$(document).on('favorites-updated-single', function(event, favorites, post_id, site_id, status){
		});
	}

	$('.close-modal').on('click', function() {
		$('.not-login-modal').fadeOut(100);
	});

	// Success Registration Message
	if ( $('.login-page .wrap .form .alert').is('.wppb-success') ) {
		console.log('success');
		$('.register').hide(); 
    	$('.reg-success').show(); 
	}


	// Calculator
	var $personscount = $('.person-calculator .number-of-persons').val();

	$('.minus').click(function() {
		console.log('minus');
		var $input = $(this).parent().find('.number-of-persons');
		var count = parseInt($input.val()) - 1;
		count = count < 1 ? 1 : count;
		$input.val(count);
		$input.change();
		$personscount = $input.val();

		changePersonsQnt($personscount);

		return false;
	});

	$('.plus').click(function() {
		console.log('plus');
		var $input = $(this).parent().find('.number-of-persons');
		$input.val(parseInt($input.val()) + 1);
		$input.change();
		$personscount = $input.val();

		changePersonsQnt($personscount);

		return false;
	});

	function changePersonsQnt($personscount) {
		$('.ingridient-quantity').each(function() {
			var regex = /[+-]?\d+(\.\d+)?/g;
  			var newCount = $(this).data('id');

  			if (newCount.toString().match(regex) == null){
  				return true;
  			}	
  			
  			var floats = newCount.toString().match(regex).map(function(v) { return parseFloat(v); } ) * $personscount / $('.number-of-persons').data('id');
  			var updatedCount = newCount.toString().replace(regex,floats.toFixed(2));

  			$(this).text(updatedCount);

		});
	}

	// Add to Boodsharpen	
	$('body').on('click', '.add-to-list', function() {
		console.log('click');
		$.ajax({
			url: '',
			type: "get", //send it through get method
			data: { 
				add_reciept_list: $personscount,
				defaultPersons: $('.number-of-persons').data('id')
			},
			success: function(response) {
				$('.add-to-list').html(' Toegevoegd aan "Mijn Boodschappen" ').addClass('added-to-list');
				//Do Something
			},
			error: function(xhr) {
				//Do Something to handle error
			}
		});
		return false;
	});

	// Add to notes
	$('body').on('click', '.save-note', function() {

		var $saveNote = $(this);

		$.ajax({
			url: '',
			type: "get", //send it through get method
			data: { 
				wp_notes: $saveNote.siblings('.note-area').val(),
				post_id: $saveNote.siblings('.note-area').data('id')
			},
			success: function(response) {
				$saveNote.html('Opgeslagen').addClass('note-saved');
				//Do Something
			},
			error: function(xhr) {
				//Do Something to handle error
			}
		});
		return false;
	});
	
	$.ajaxSetup({ cache: false });
	
	$('body').on('click', '.remove-from-list', function() {

		console.log('click!');

		var $removeBtn = $(this);

		$.ajax({
			url: '',
			type: "get",
			data: { 
				post_id: $(this).data('id'),
				delete: '1'
			},
			success: function(response) {
				console.log('remove-success!');
				$removeBtn.closest('.block').remove();

			},
			error: function(xhr) {
				//Do Something to handle error
			}
		});
		return false;
	});

	// Reciepts Filter
	jQuery('.reciepts-filter a').first().addClass('active');
    jQuery('.reciepts-filter a').on('click', function(e){
        e.preventDefault();
        jQuery('.reciepts-filter a').removeClass('active');
        jQuery(this).addClass('active');
        var service = jQuery(this).data('service-id');
        $.ajax({
            type: "POST",
            url: window.wp_data.ajax_url,
            data : {
                action : 'get_projects',
                service_id : service
            },
            success: function (data) {
                jQuery('#ajax-portfolio-container').html(data);
                $('#ajax-portfolio-container .project-block a').css('opacity', 1);
            }
        });
    });

	// Chicken Sheme
	if ($(window).width() > 767) {	
		
		$('a[*|href^="#"]').on('click',function (e) {
			e.preventDefault();
		
			var target = $(this).attr('xlink:href');
			var $target = $(target);
		
			$('html, body').animate({
				'scrollTop': $target.offset().top - 140,
			},  function () {
				// window.location.hash = target;
			});
		});
	}

	if ($(window).width() < 767) {

		$('a[*|href^="#"]').on('click',function (e) {
			return false;
			e.preventDefault();
		
		});
	}

	$('.chicken-tabs a').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('.chicken-tabs a').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	});


	// Mobile
	if ($(window).width() < 767) {
		$('#mobile-recepts-slider').owlCarousel({
			smartSpeed: 200,
			mouseDrag: false,
			items: 2,
			margin: 1,
			stagePadding: 1,
		    loop: true,
		    margin: 0,
		    nav: false,
		    dots: true,
		    responsiveClass: true
		});
	}

	if ($(window).width() < 767) {
		$('#mobile-related-slider').owlCarousel({
			smartSpeed: 200,
			mouseDrag: false,
			items: 2,
			margin: 1,
			stagePadding: 1,
		    loop: true,
		    margin: 0,
		    nav: false,
		    dots: true,
		    responsiveClass: true
		});
	}

	// Hide Newsletter
	document.addEventListener( 'wpcf7mailsent', function( event ) {
		$('.nl-inputs-wrap').hide();
		$('.nl-success').show();
	}, false );


	$('.reciept-generator-page .options-list .option').on('click', function() {
		$('.reciept-generator-page .options-list .option').removeClass('chosen');
		$(this).addClass('chosen');
	});

});


























